<script>
  import { defineComponent } from "vue";
  import Dialog from "primevue/dialog";
  import Button from "primevue/button";
  import { useI18n } from "vue-i18n";

  export default defineComponent({
  name: "Alert Dialog",
  emits: [
    "rejected",
    "accepted"
  ],
  props: {
    visible: Boolean,
    header: String,
    action: String,
    acceptLabel:String,
    rejectLabel: String,
    key: String
  },
  setup() {
    const {t} = useI18n();
    return {
      t
    };
  },
  methods: {
    onClosed() {
      this.$emit("rejected");
    },
    onAccept() {
      this.$emit("accepted", this.key);
    }
  },
  computed: {
    dialogTitle() {
      return this.header || ''
    },
    dialogVisible() {
      return (this.visible || false);
    },
    acceptBtnLabel() {
      return this.acceptLabel || this.t('accept');
    },
    rejectBtnLabel() {
      return this.rejectLabel || this.t('reject');
    },
    isActionDelete() {
      return this.action === 'delete';
    },
    isActionSave() {
      return this.action === 'save';
    },
    dialogIcon() {
      return this.isActionDelete ? "pi-exclamation-circle" :
             this.isActionSave ? "pi-download" : "pi-question-circle";
    }
  },

  components: {
    Dialog,
    Button
    
  }
});
 
</script>

<template>
  <Dialog
  class="alert-dialog"
  v-model:visible="dialogVisible"
  :header="dialogTitle"
  :modal="true"
  :closable=false
  style="min-width:480px;"
  :pt="{
      content: { class: 'w-12'},
      footer: { class: 'alert-footer' }
    }"
  >
    <template #header>
      <i class="pi " :class="dialogIcon"></i>
    </template>
    <slot></slot>
    <template #footer>
      <Button
        :label="acceptBtnLabel"
        @click="onAccept"
        :class="action"
        class="button-accept">
      </Button>
      <Button
        :label="rejectBtnLabel"
        @click="onClosed"
        class="button-reject"
        autofocus>
      </Button>
    </template>
  </Dialog>
</template>

<style lang="scss">
@import "@/styles/variables";
 .alert-dialog {
  &.p-dialog {
    
    border-radius: 10px;
    box-shadow: 0px 4px 30px 0px #0000001A;

    .p-dialog-header {
      justify-content: center;
      padding: 32px;
      font-size: 40px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      >i {
        font-size: 40px;
        &.pi-exclamation-circle {
          color: $BrinkPink;
        }
        &.pi-download {
          color: $RoyalBlue;
        }
        &.question-circle {
          color: $RoyalBlue;
        }
      }
    }
    .p-dialog-content {
      text-align: center;
      font-size: 22px;
      font-weight: 500;
    }

    .p-dialog-footer {
      display: flex;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      button {
        margin-left: 8px;
        margin-right: 8px;
        &:first-child {
          margin-left: 0px;
        }
        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }
}

</style>
<style lang="scss" scoped>
@import "@/styles/mixin";
  .delete {
    &.button-accept {
      background-color: $BrinkPink;
      border-color: $BrinkPink;
    }
  }
  .save {
    &.button-accept {
      background-color: $RoyalBlue;
      border-color: $RoyalBlue;
    }
  }

 

  .button-accept {
    background-color: $RoyalBlue;
    border-color: $RoyalBlue;
    color: #fff !important;
    border-radius: 6px;
    padding: 12px 24px;
    flex-grow: 1;
  }
  .button-reject {
    background-color: $Grey2;
    border-color: $Grey2;
    color: #fff !important;
    border-radius: 6px;
    padding: 12px 24px;
    flex-grow: 1;
  }


  ::slotted(.p-dialog .p-dialog-footer) {
        background-color: #f00 !important;
  }

</style>